import { ProfileResource, profileResource } from '@witkac/kartamiejska-resources';
import { Profile } from '@witkac/kartamiejska-shared';

import { AbstractModule } from './abstract.module';
import cards from './client/cards.module';
import groups from './client/groups.module';

/**
 * Moduł klienta
 *
 * @export
 * @class ClientModule
 * @extends {AbstractModule<ProfileResource>}
 */
export class ClientModule extends AbstractModule<ProfileResource> {
  /**
   * Stan store
   *
   * Zawiera dane klienta
   *
   * @memberof ClientModule
   */
  public state = {
    data: {
      profile: {
        id: undefined,
        firstName: undefined,
        lastName: undefined,
        pesel: undefined,
        email: undefined,
        phoneNumber: undefined,
        state: undefined,
        gender: undefined,
        address: undefined,
        confirmReason: undefined,
        confirmReasonDescription: undefined,
        woj: undefined,
        pow: undefined,
        gmi: undefined,
        terc: undefined,
        city: undefined,
        simc: undefined,
        street: undefined,
        ulic: undefined,
        postalCode: undefined,
        homeNumber: undefined,
        localNumber: undefined,
        mainImage: undefined,
        userId: undefined
      },
      login: undefined
    },
    id: undefined
  };

  public mutations = {
    /**
     * Ustawia identyfikator klienta do store
     *
     * @param localState stan lokalny
     * @param id identyfikator klienta
     */
    setId(localState: any, id: number): void {
      localState.id = id;
    },
    /**
     * Zapisuje klienta do store
     *
     * @param localState stan lokalny
     * @param profile profil klienta
     */
    save(localState: any, profile: any): void {
      Object.keys(localState.data.profile)
        .filter(key => profile[key] !== undefined)
        .forEach(key => (localState.data.profile[key] = profile[key]));
      if (profile.user) {
        localState.data.login = profile.user.login;
      }
    }
  };

  public actions = {
    /**
     * Pobiera dane klienta
     *
     * @param context context
     */
    get: async (context: any): Promise<Profile> => {
      const profile = await this.resource.get(context.state.id);
      context.commit('save', profile);
      return profile;
    },
    /**
     * Aktualizuje dane klienta
     *
     * @param context context
     * @param data profil klienta
     */
    update: async (context: any, data: { id: number; profile: Profile }): Promise<void> => {
      const args = { ...data.profile };
      await this.resource.update(data.id as number, args);
      context.commit('save', data.profile);
    }
  };

  /**
   * Submoduły klienta
   *  karty, historia, usługi, grupy
   *
   * @memberof ClientModule
   */
  public modules = { cards, groups };

  constructor() {
    super(profileResource);
  }
}

export default new ClientModule();
